<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{resource?.DisplayName}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body" *ngIf="(resource$ | async) as resource; else loading">
  <mes-web-resource-edit [resource]="resource"
                         [wasValidated$]="wasValidated$"
                         [response]="response"
                         (changed)="onChanged($event)"/>
</div>
<ng-template #loading>Loading...</ng-template>
<mes-web-edit-modal-buttons [entityId]="entityId"
                            [hasDeleteButton]="!!entityId"
                            [isPristine]="isPristine$ | async"
                            [displayName]="resource?.DisplayName"
                            [requiredPrivileges]="[PRIVILEGES.EditManufacturing]"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (addClick)="add()"
                            (cancelClick)="bsModalRef.dismiss()"/>
